<template>
	<div class="d-flex align-center">
		<div class="d-flex align-center">
			<v-select
				v-model="localOptions.itemsPerPage"
				:items="itemsPerPageOptions"
				:loading="loadingInfo"
				:menu-props="{ top: true, offsetY: true }"
				label="Items por página"
				class="custom-height-search custom-height-calendar mb-0 mr-1 w-100"
				outlined
				dense
				return-object
				required
				style="max-width: 120px;"
			></v-select>
			<v-select
				v-if="showOrderBy"
				v-model="localOptions.order_by"
				:items="orderByOptions"
				:loading="loadingInfo"
				:menu-props="{ top: true, offsetY: true }"
				label="Ordenar Por"
				class="custom-height-search custom-height-calendar mb-0 mr-1 w-100"
				outlined
				dense
				required
				style="max-width: 140px;"
				@change="changedOrderBy"
			></v-select>
			<v-btn icon @click="previousPage" :disabled="localOptions.page <= 1 || loadingInfo">
				<v-icon>mdi-chevron-left</v-icon>
			</v-btn>
			<v-btn icon @click="nextPage" :disabled="localOptions.page >= Math.ceil(itemLength / localOptions.itemsPerPage) || loadingInfo">
				<v-icon>mdi-chevron-right</v-icon>
			</v-btn>
		</div>
		<v-divider vertical class="mx-2"></v-divider>
		<div class="d-flex align-center caption">
			{{ (localOptions.page - 1) * localOptions.itemsPerPage + 1 }} a {{ Math.min(localOptions.page * localOptions.itemsPerPage, itemLength) }} de {{ itemLength }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'DataTablePagination',
	props: {
		options: {
			type: Object,
			required: true
		},
		itemsType: {
			type: String,
			required: false
		},
		itemLength: {
			type: Number,
			required: true
		},
		loadingInfo: {
			type: Boolean,
			required: true
		},
		showOrderBy: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		localOptions: {
			get() {
				return this.options;
			},
			set(newVal) {
				this.$emit('update:options', newVal);
			},
		},
	},
	watch: {
	},
	data() {
		return {
			itemsPerPageOptions: [10, 25, 50, 100, 200, 500],
			orderByOptions: [{value: 1, text: 'Fecha de Creación'}, {value: 2, text: 'ID Línea de Proyecto'}],
		}
	},
	mounted(){
	},
	methods:{
		changedOrderBy(order_by){
			if(this.itemsType){
				localStorage.setItem(`${this.itemsType}_order_by`, order_by);
			}
		},
		previousPage() {
			if (this.localOptions.page > 1) {
				this.localOptions.page--;
			}
		},
		nextPage() {
			const totalPages = Math.ceil(this.itemLength / this.localOptions.itemsPerPage);
			if (this.localOptions.page < totalPages) {
				this.localOptions.page++;
			}
		},
	}
}
</script>